import React from 'react';
import PropTypes from 'prop-types';

function IconSettings({ className, style }) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" className={className} style={style} fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_9341_5612)">
        <path d="M8 10.5C9.38071 10.5 10.5 9.38071 10.5 8C10.5 6.61929 9.38071 5.5 8 5.5C6.61929 5.5 5.5 6.61929 5.5 8C5.5 9.38071 6.61929 10.5 8 10.5Z" stroke="#B3B3B3" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M8.12814 12.8819C8.04439 12.8819 7.96002 12.8819 7.87814 12.8819L5.87502 14C5.09522 13.7377 4.37194 13.3306 3.74314 12.8L3.73564 10.55C3.69127 10.48 3.64939 10.4094 3.61064 10.3369L1.61877 9.2025C1.46188 8.40893 1.46188 7.59232 1.61877 6.79875L3.60877 5.6675C3.64939 5.59563 3.69127 5.52437 3.73377 5.45437L3.74377 3.20438C4.37199 2.67228 5.09509 2.26365 5.87502 2L7.87502 3.11812C7.95877 3.11812 8.04314 3.11812 8.12502 3.11812L10.125 2C10.9048 2.2623 11.6281 2.66943 12.2569 3.2L12.2644 5.45C12.3088 5.52 12.3506 5.59063 12.3894 5.66313L14.38 6.79688C14.5369 7.59044 14.5369 8.40706 14.38 9.20063L12.39 10.3319C12.3494 10.4037 12.3075 10.475 12.265 10.545L12.255 12.795C11.6272 13.3272 10.9045 13.736 10.125 14L8.12814 12.8819Z" stroke="#B3B3B3" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_9341_5612">
          <rect width="16" height="16" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  )
}

IconSettings.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
}

export default IconSettings;
